import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import ReactTooltip from 'react-tooltip';
import ReviewsSection from '../../components/ReviewsSection';
import RatingBox from '../../components/RatingBox';
import PDItemCardLoader from '../../components/PDItemCardLoader';
import EmiModal from '../../components/EmiModal';
import BankOfferModal from '../../components/BankOfferModal';
import { mutateItemObjectWithCartData } from '@/utils/mutateItemObjectWithCartData';
import { mutateVariantItemWithCartData } from '@/utils/mutateVariantItemWithCartData';
import {
  fetchSimilarCatalogItems,
  getAllEmiOptions,
  saveCart,
  saveCatalogCategories,
  saveCatalogTags,
  saveDetailedItemById,
  saveProductLoaderId,
  saveStoreInfo,
  setCart,
  setChooseAndRepeatModalVisibility,
  setSelectedVariantModalVisibility,
  setVariantModalVisibility,
  verifyBuyerForItem,
  getCustomerReviewSettings,
  pushEventsLog,
  toggleRfqFormModal,
} from '../../redux/actions';
import { PATH, getRoute } from '@/utils/routes';
import { storeItemClickedDetails } from '@/utils/storeItemClickedDetails';
import { deviceWidth } from '@/utils/deviceWidth';
import { returnCommonConfigData } from '@/utils/returnCommonConfigData';
import { selectedVariantFromVariantList } from '@/utils/selectedVariantFromVariantList';
import { isStoreGstExcluded, isStoreGstIncluded } from '@/utils/storeGSTStatus';
import { isNotifyProductEnabled } from '@/utils/isNotifyProductEnabled';
import { itemIndexFromCart } from '@/utils/itemIndexFromCart';
import { checkForLimitedQuantity } from '@/utils/checkForLimitedQuantity';
import { isStoreServiceBased } from '@/utils/isStoreServiceBased';
import { getStoreType } from '@/utils/getStoreType';
import { getItemAmountForPDP } from '@/utils/getItemAmountForPDP';
import { getThemeComponent } from '@/utils/themeImports';
import { Card } from '@/components/DesignSystem/Card';
import { NoStoreInfoIcon } from '@/assets/svgExports/NoStoreInfoIcon';
import { checkIfObjectExists } from '@/utils/checkIfObjectExists';
import VariantModal from '../../components/VariantModal';
import VariantChooseRepeatModal from '../../components/VariantChooseRepeatModal';
import VariantSelectedListModal from '../../components/VariantSelectedListModal';
import { getDeviceInfo } from '@/utils/deviceInfo';
import { ProductCardWidget1 } from '@/components/DesignSystem/ProductItemWidget';
import { CURRENCY_SYMBOL } from 'src/config';
import CheckItemDelivery from '@/components/CheckItemDelivery/CheckItemDelivery';
import DetailedDescription from '@/components/Common/DetailedDescription';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import useIsComponentMounted from '@/utils/useIsComponentMounted';
import {
  ITEM_ACTIVE_STATUS,
  MAX_MOBILE_WIDTH,
  STORE_CUSTOMIZATION,
  VARIANT_OPTIONS,
} from '@/utils/constants';
import MobileImageComponent from './Components/MobileImageComponent/MobileImageComponent';
import DesktopImageComponent from './Components/DesktopImageComponent/DesktopImageComponent';
import CartCtaMobile from './Components/PdpCartCta/CartCtaMobile';
import VariantDescription from './Components/VariantDescription/VariantDescription';
import ImageDescriptionModal from './Components/ImageDescriptionModal/ImageDescriptionModal';
import MoreInfoTable from './Components/MoreInfoTable/MoreInfoTable';
import CartCtaDesktop from './Components/PdpCartCta/CartCtaDesktop';
import NotifyProduct from '@/components/NotifyProduct';
import { useFeatureLocks } from '@/hooks/useFeatureLocks';
import {
  B2bProductPriceRange,
  B2bRequestForQuoteDesktop,
  B2bRequestForQuoteMobile,
} from './Components/B2b';
import AuthModal from '@/components/DesignSystem/AuthPopUp';
import moment from 'moment';
import useAddVariantIdOnPdp from '../../hooks/useAddVariantIdOnPdp';
import { getVariantIdFromUrl } from './Utils/common';
import { getDiscountPercentage } from '@/utils/getDiscountPercentage';
import { specificThemeRender } from '@/utils/specificThemeRender';
import LocalStorageHelper from '../../utils/LocalStorageHelper';
import {
  MB7_SORT_FILTER_TEMP_STORAGE_KEY,
  setMB7SortAndFilterConfig,
} from '../../components/DesignSystem/MiddleBody/MiddleBody7/utils';
import { useSSRSelector } from '@/redux/ssrStore';
import { ProductCustomizationPopUp } from '../../components/ProductCustomizationPopUp';
import { FullPageLoader } from '../../components/FullPageLoader/FullPageLoader';
import { useCartHandlers } from '../../hooks/useCartHandler';
import AllProductPagePromos from 'src/components/CouponsAndVouchers/AllProductPagePromos';
import { PROMO_APPLICABILITY_TYPES } from 'src/constants/promos';
import SatisfiedBogoPromos from 'src/components/CouponsAndVouchers/SatisfiedBogoPromos';
import { ProductCard } from 'src/components/DesignSystem/Widgets2.0/ProductCard';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { getCartWrapperConfigs } from 'src/components/DesignSystem/Widgets2.0/ProductCard/utils';
import { useGetDeviceType } from 'src/hooks/useGetDeviceType';
import { IS_SERVER } from 'src/utils/checkRenderEnv';
import QuntityUnavailableAlert from 'src/components/QuntityUnavailableAlert';

const MIN_EMI_AMOUNT = 2500;

const ProductDescPage = ({ product, catalogCategories, catalogTags }) => {
  const bodyElement = !IS_SERVER ? document.getElementsByTagName('body')[0] : null;
  const dispatch = useDispatch();
  const router = useRouter();
  const { deviceType } = useGetDeviceType();
  const isMobile = deviceType === 'mobile';
  const showDetailedDescription = product?.description_detail;
  const [state, setState] = useState({
    itemCartIdx: -1, // item index for selected item
    cartCount: 0,
    showFullImage: {
      show: false,
      currentIndex: 0,
    },
    discountPercentage: 0,
    activeVariant: -1, // selected variant index if variant exists for item
    OSName: null,
    ownerNumber: null,
    isRedirect: false,
    cost: {
      discounted_price: 0,
      price: 0,
      price_range: 0,
    },
    viewDescription: false,
    selectedVariantId: -1, // id of selected variant from variant list
    additionalRemark: [],
    showAuthModal: false,
    isMainProductLink: false,
  });
  const [emiModalShow, setEmiModalShow] = useState(false);
  const [variantOutOfStock, setVariantOutOfStock] = useState(false);
  const [bankOfferModal, setBankOfferModal] = useState(false);
  const [verifedBuyer, setVerifiedBuyer] = useState(false);
  const [showImageDescModal, setShowImageDescModal] = useState(false);
  const [variantInitColor, setVariantInitColor] = useState('');
  const [availableSuggestions, setAvailableSuggestions] = useState([]);
  const {
    widgetContextState: { globalStyle },
  } = useWidgetDndContextData();
  const { infoList, isEnabled: isProductCardEnabled } = globalStyle?.productCard || {
    infoList: [],
    isEnabled: false,
  };
  const showCustomProductCard = isProductCardEnabled && infoList?.length ? true : false;

  // it holds index value of image that is clicked from pdp to be opened in imageDescModal
  const [mainImageIndexFromPdp, setMainImageIndexFromPdp] = useState(0);
  const isComponentMounted = useIsComponentMounted();

  const { storeInfo } = useSSRSelector((state) => ({
    storeInfo: state.storeReducer.store,
  }));

  useLayoutEffect(() => {
    if (bodyElement && (isMobile || deviceWidth <= MAX_MOBILE_WIDTH)) {
      bodyElement.classList.add('!tw-overflow-hidden');
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0 });
    }, 20);
    setTimeout(() => {
      if (bodyElement) {
        bodyElement.classList.remove('!tw-overflow-hidden');
      }
    }, 1100);
  }, [router.query.pid, router.query.pname]);

  const isB2bStore = getStoreType(storeInfo) === STORE_CUSTOMIZATION.B2B;

  const toggleEmiModal = () => {
    if (deviceWidth <= MAX_MOBILE_WIDTH) {
      router.push(
        getRoute(
          PATH.emiOptions(state.cost.discounted_price),
          storeInfo.store_info.domain
        ),
        undefined,
        { scroll: false }
      );
    } else {
      setEmiModalShow((s) => !s);
    }
  };

  const toggleBankOfferModal = () => {
    setBankOfferModal((s) => !s);
  };

  const {
    cartData,
    loader,
    similar_suggestions,
    suggestions,
    theme,
    allEmiOptions,
    paymentOffersList,
    userData,
    reviewSettings,
    personalizedProduct,
  } = useSelector((state: any) => ({
    cartData: state.cartReducer,
    loader: state.commonReducer.loader,
    suggestions: state.catalogReducer.sharePDP.suggestions,
    similar_suggestions: state.catalogReducer.sharePDP.similar_suggestions,
    theme: state.storeReducer.store.theme,
    allEmiOptions: state.emiReducer.allEmiOptions,
    paymentOffersList: state.promoReducer.paymentOffersList,
    userData: state.userReducer,
    reviewSettings: state.catalogReducer.reviewSettings,
    personalizedProduct: state.catalogReducer?.personalizedProduct,
  }));

  const { category } = useSelector((state: any) => ({
    category: similar_suggestions
      ? state.catalogReducer?.sharePDP?.suggestions?.[0]?.category
      : state.catalogReducer?.categories?.[0],
  }));

  const { crrFeatureStatus, notifyMeFeatureStatus } = useFeatureLocks();
  const isCRRFeatureUnlocked = !crrFeatureStatus?.isLocked;
  const isNotifyMeFeatureVisible = notifyMeFeatureStatus?.isVisible;
  const itemIndexInCart = itemIndexFromCart(cartData, product);
  const phoneNo = storeInfo && (storeInfo?.display_phone || storeInfo?.owner?.phone);

  const { handleSetProductData, handleSetProductCustomizationCount } = useCartHandlers();

  useEffect(() => {
    if (suggestions?.length) {
      setAvailableSuggestions(suggestions.filter((item) => !!item.available));
    }
  }, [suggestions]);

  /**
   * call getAllEmiOptionsInfo api when
   * discounted_price is >= 2500
   */
  useEffect(() => {
    if (
      state.cost?.discounted_price &&
      state.cost?.discounted_price >= MIN_EMI_AMOUNT &&
      checkIfObjectExists(storeInfo)
    ) {
      dispatch(
        getAllEmiOptions({
          amount: state.cost?.discounted_price,
          store_id: storeInfo?.store_id,
        })
      );
    }
  }, [state.cost?.discounted_price, storeInfo?.store_id]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const mb7SortAndFilterConfigTemp = LocalStorageHelper.get(
      MB7_SORT_FILTER_TEMP_STORAGE_KEY
    );
    if (utmSource && localStorage?.getItem('utm_source') !== utmSource) {
      localStorage?.setItem('utm_source', utmSource);
    }
    if (mb7SortAndFilterConfigTemp) {
      LocalStorageHelper.delete(MB7_SORT_FILTER_TEMP_STORAGE_KEY);
      setMB7SortAndFilterConfig({ ...mb7SortAndFilterConfigTemp });
    }
    storeItemClickedDetails(product?.id);
  }, []);

  useEffect(() => {
    if (cartData.items && cartData.items.length > 0) {
      setCartAsyncCall();
    }
  }, [cartData.amount, cartData.pay_amount]);

  const setCartAsyncCall = () => {
    return new Promise((resolve) => {
      dispatch(
        setCart(
          {
            ...cartData,
            order_type: cartData.order_type,
            store_id: storeInfo?.store_id,
            user_phone: cartData.phone,
            cart_id: cartData.cart_id,
          },
          (status) => {
            resolve(status);
          }
        )
      );
    });
  };

  useEffect(() => {
    /** Save store info **/
    if (storeInfo.store_id) {
      dispatch(saveStoreInfo(storeInfo));
    }

    if (storeInfo?.store_id && product?.category?.id && product?.id) {
      dispatch(
        fetchSimilarCatalogItems({
          store_id: storeInfo?.store_id,
          category_id: product?.category?.id,
          item_id: product?.id,
        })
      );
    }

    if (catalogCategories && catalogCategories?.length > 0)
      dispatch(saveCatalogCategories(catalogCategories));
    /** Save tags list */
    if (catalogTags && catalogTags?.length > 0) {
      dispatch(saveCatalogTags(catalogTags));
    }

    // store owner number and os type
    const { OSName } = getDeviceInfo();

    /** find the first active variant index */
    let { activeVariantIndex, isMainProductLink } = findActiveVariantIndex(product);
    if (product?.variants?.length && activeVariantIndex === -1) activeVariantIndex = 0;

    product?.variants?.length &&
      activeVariantIndex != -1 &&
      setVariantOutOfStock(!product?.variants?.[activeVariantIndex]?.available);
    setState((state) => ({
      ...state,
      OSName: OSName,
      ownerNumber: storeInfo && storeInfo?.owner?.phone,
      activeVariant: activeVariantIndex,
      selectedVariantId: product?.variants?.[activeVariantIndex]?.variant_id ?? -1,
      cost: getItemAmountForPDP(product, product?.variants_count > 0 ? 0 : -1),
      isMainProductLink: isMainProductLink,
    }));
    if (userData?.isLogin) {
      const data: any = {
        phone: userData?.data?.phone || '',
        item_id: product?.id,
      };
      if (data.phone === '') {
        data.user_id = userData?.data?.user_id || '';
      }
      dispatch(verifyBuyerForItem(data, (data) => setVerifiedBuyer(data)));
    }
    if (storeInfo?.store_id) {
      dispatch(getCustomerReviewSettings(storeInfo.store_id));
    }
  }, [variantInitColor, router.query.pid, router.query.pname]);

  useEffect(() => {
    if (cartData?.items?.length >= 0) {
      const itemCartIdx = cartData.items.findIndex(
        (el) => (el.id || el.item_id) === product.id
      );

      setState((state) => ({
        ...state,
        cartCount: cartData.items.length,
        itemCartIdx,
      }));
    }
  }, [cartData]);

  useEffect(() => {
    if (state.cost.discounted_price !== state.cost.price) {
      const percent = getDiscountPercentage(
        state.cost.price,
        state.cost.discounted_price
      );
      setState((state) => ({
        ...state,
        discountPercentage: percent,
      }));
    }
  }, [state.cost]);

  useEffect(() => {
    if (state.activeVariant > -1 && product?.variants) {
      const _cost = getItemAmountForPDP(product, state.activeVariant);
      setState((state) => ({
        ...state,
        cost: _cost,
        discountPercentage: getDiscountPercentage(_cost.price, _cost.discounted_price),
      }));
    }
  }, [state.activeVariant, router.query.pid, router.query.pname]);

  /**
   * useEffect to open a fullscreen
   * modal for mobile phones
   */
  useEffect(() => {
    if (router.query.immersive_view) {
      setState((state) => ({
        ...state,
        showFullImage: {
          show: true,
          currentIndex: Number(router.query.immersive_view),
        },
      }));
    } else {
      setState((state) => ({
        ...state,
        showFullImage: { show: false, currentIndex: 0 },
      }));
    }
  }, [router.query.immersive_view]);

  useEffect(() => {
    hydrateAdditionalRemarks();
  }, [cartData]);

  useAddVariantIdOnPdp({
    activeVariant: state.activeVariant,
    product,
    isMainProductLink: state.isMainProductLink,
  });
  useEffect(() => {
    const urlArray = window.location.href.split('=');
    if (urlArray?.length === 2) setVariantInitColor(urlArray[urlArray?.length - 1]);
    handleSetProductData(product);
    dispatch(saveDetailedItemById(product));
  }, []);

  useEffect(() => {
    if (product?.product_personalization) {
      handleSetProductCustomizationCount(product);
    }
  }, [product?.product_personalization]);

  function findActiveVariantIndex(product) {
    const variantIdFromUrl = getVariantIdFromUrl();
    if (variantIdFromUrl) {
      return {
        activeVariantIndex: product.variants.findIndex(
          (variant) => variantIdFromUrl === variant?.variant_id
        ),
        isMainProductLink: false,
      };
    }
    if (variantInitColor) {
      return {
        activeVariantIndex: product.variants.findIndex((el) => {
          return (
            el.status === ITEM_ACTIVE_STATUS.ACTIVE &&
            el?.option_variant_names.find((variantOptions) => {
              return (
                variantOptions?.option_name === VARIANT_OPTIONS.COLOR &&
                variantOptions?.colour_code === variantInitColor
              );
            })
          );
        }),
        isMainProductLink: false,
      };
    } else {
      return {
        activeVariantIndex: product.variants.findIndex(
          (el) => el.status === ITEM_ACTIVE_STATUS.ACTIVE
        ),
        isMainProductLink: variantIdFromUrl ? false : true,
      };
    }
  }

  const handleCart = async (type, count = null) => {
    /** Check if variant present in this item */
    if (!product.available) return;
    if (product.variants_count > 0) {
      dispatch(saveProductLoaderId(product.id));
      dispatch(saveDetailedItemById(product));
      /** If variant not pre selected */
      if (state.activeVariant === -1) {
        switch (type) {
          case 'add':
            dispatch(setVariantModalVisibility(true));
            break;
          case 'inc':
            dispatch(setChooseAndRepeatModalVisibility(true));
            break;
          case 'dec':
            dispatch(setSelectedVariantModalVisibility(true));
            break;
        }
      } else {
        /** If variants are preselected */
        dispatch(setVariantModalVisibility(false));
        let newCart = [];
        type = type === 'add' || type === 'inc' ? 'inc' : type;
        newCart = mutateVariantItemWithCartData(
          type,
          product,
          product.variants[state.activeVariant],
          cartData,
          null,
          null,
          null,
          count
        );
        const data = await saveAdditionalRemark(newCart);
        dispatch(saveCart(data));
      }
    } else {
      const newState = mutateItemObjectWithCartData(
        type,
        product,
        cartData,
        null,
        null,
        null,
        count
      );
      const data = await saveAdditionalRemark(newState);
      dispatch(saveCart(data));
    }
    dispatch(
      pushEventsLog({
        event_name: 'Cx_ATC',
        data: {
          store_id: storeInfo?.store_id,
          domain: storeInfo?.store_info?.domain,
          page: window.location.href,
          device: deviceWidth <= MAX_MOBILE_WIDTH ? 'Mobile' : 'Desktop',
          cx_number: userData?.data?.phone,
        },
      })
    );
  };

  const onSuggestiveItemTap = (item) => {
    // window.scrollTo({ left: 0, top: 0 });
    const link = getRoute(
      PATH.productDescription(
        item.id,
        item.name.replace(/[&\/\\#, +()$~%.'":*?<>{}\n]/g, '-')
      ),
      storeInfo.store_info.domain
    );

    if (!isMobile) router.push(link, undefined, { scroll: false, shallow: false });
    else window.location.href = link;
  };

  const goToHomePage = () => {
    if (!storeInfo.premium) {
      router.push(getRoute(PATH.PRODUCT, storeInfo.store_info.domain));
    } else {
      router.push(
        getRoute(`${PATH.SHOP}?cid=${category.id}`, storeInfo.store_info.domain)
      );
    }
  };

  const onBuyNowClick = () => {
    setState((state) => ({ ...state, isRedirect: true }));
    const itemIndex = itemIndexFromCart(cartData, product);
    if (itemIndex === -1) handleCart('add');

    router.push(getRoute(PATH.CART, storeInfo?.store_info?.domain));
  };

  /**
   * utility function to get quantity and current item data of product
   * @return {*} { quantity: num; selectedItem: any }
   */
  const returnItemData = () => {
    let itemData = {
      quantity: 0,
      selectedItem: null,
    };

    if (itemIndexInCart >= 0) {
      if (cartData?.items?.[itemIndexInCart]?.variants_selected?.length) {
        const selectedVariant = selectedVariantFromVariantList(
          cartData,
          itemIndexInCart,
          state.selectedVariantId
        );
        itemData = {
          quantity: selectedVariant?.quantity ?? 0,
          selectedItem: selectedVariant ? selectedVariant : null,
        };
      } else {
        itemData = {
          quantity: cartData?.items?.[itemIndexInCart]?.quantity,
          selectedItem: cartData?.items?.[itemIndexInCart],
        };
      }
    }
    return itemData;
  };

  const disabledAdditionComponent = () => {
    const { selectedItem } = returnItemData();
    if (
      selectedItem &&
      !!Object.keys(selectedItem).length &&
      selectedItem.managed_inventory
    ) {
      return selectedItem.quantity < selectedItem.available_quantity;
    }
    return true;
  };

  const onVariantSelect = (selectedInd, item) => {
    setState((state) => ({
      ...state,
      activeVariant: selectedInd,
      selectedVariantId: item.variant_id,
      isMainProductLink: false,
    }));
    setVariantOutOfStock(!item.available);
  };

  const numberClickFunc = (e) => {
    if (
      !(
        (state.OSName === 'Android' || state.OSName === 'iPhone') &&
        deviceWidth < MAX_MOBILE_WIDTH
      )
    ) {
      e.preventDefault();
    }
  };

  /**
   * toggle function for product
   * Discription
   */
  const toggleViewDescription = () => {
    /**
     * if use  collapsing the discription than
     * scroll the screen to the top
     */
    if (state.viewDescription && window) {
      window?.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    setState((state) => ({
      ...state,
      viewDescription: !state.viewDescription,
    }));
  };

  // different card based on whether custom website is enabled or not
  const conditionalCardRender = (item, idx) => {
    if (showCustomProductCard) {
      const layoutElement = infoList?.find((item) => item.type === 'layout');
      const cardWrapperConfigs = getCartWrapperConfigs(layoutElement?.config);
      return (
        <ProductCard
          onItemClick={onSuggestiveItemTap}
          key={item.id}
          productData={item}
          itemIndex={idx}
          configs={{
            cardWrapperConfigs,
            isMobile,
            dimensions: { cardHeight: 'auto', cardWidth: 200 },
          }}
        />
      );
    }
    return theme?.custom_theme_flag ? (
      <ProductCardWidget1
        isPdp={true}
        key={item.id}
        data={item}
        onItemClick={() => onSuggestiveItemTap(item)}
        showButton={false}
        categoryConfig={returnCommonConfigData({
          activeCategoryConfig: { animation: 'pop' },
        })}
      />
    ) : (
      <Card
        isPdp={true}
        key={item.id}
        data={item}
        onItemClick={() => onSuggestiveItemTap(item)}
        showButton={true}
      />
    );
  };
  const checkForEmiOptionsShowcase = () =>
    !!storeInfo?.services?.emi_flag &&
    state.cost?.discounted_price >= MIN_EMI_AMOUNT &&
    allEmiOptions?.min_emi_amount;

  /** This saves the additional remarks text belonging to the current select product or variant
   * to local state where it can be edited */
  const hydrateAdditionalRemarks = () => {
    const value = [...state.additionalRemark];
    if (itemIndexInCart === -1) return;
    if (
      state.activeVariant !== -1 &&
      cartData.items?.variants_selected?.[state.activeVariant]
    )
      cartData?.items?.[itemIndexInCart]?.variants_selected?.[state.activeVariant]
        ?.additional_remark &&
        value.push({
          id: cartData.items?.[itemIndexInCart]?.variants_selected?.[state.activeVariant]
            ?.variant_id,
          remark:
            cartData?.items?.[itemIndexInCart]?.variants_selected?.[state.activeVariant]
              ?.additional_remark || '',
        });
    else
      cartData?.items?.[itemIndexInCart]?.additional_remark &&
        value.push({
          id: cartData?.items?.[itemIndexInCart]?.item_id,
          remark: cartData?.items?.[itemIndexInCart]?.additional_remark || '',
        });
    value !== state.additionalRemark &&
      setState((state) => ({ ...state, additionalRemark: value }));
  };

  const checkIsAdditionalRemarkDisabled = () =>
    itemIndexInCart !== -1 &&
    (state.activeVariant === -1 ||
      (state.activeVariant > -1 &&
        cartData.items?.[itemIndexInCart]?.variants_selected?.find(
          (variant) =>
            variant.variant_id === product.variants[state.activeVariant].variant_id
        )));

  /** This takes additional remark text from input element & adds it to the local state along with the id (either product's/selected_variant's) it belong to
   * @param {*} remark - input value
   */
  const handleAdditionalRemarksInput = (remark) => {
    const currentID =
      state.activeVariant > -1
        ? product.variants[state.activeVariant].variant_id
        : product.id;
    let additionalRemark = [...state.additionalRemark];
    const isCurrentIdsRemarkAvailable =
      state.additionalRemark.findIndex((item) => item.id == currentID) > -1;
    if (isCurrentIdsRemarkAvailable) {
      additionalRemark = additionalRemark.map((item) =>
        item.id === currentID ? { ...item, remark } : item
      );
    } else
      additionalRemark = [
        ...state.additionalRemark,
        {
          id:
            state.activeVariant > -1
              ? product.variants[state.activeVariant].variant_id
              : product.id,
          isVariant: state.activeVariant > -1,
          remark,
        },
      ];
    setState((state) => ({ ...state, additionalRemark }));
  };

  /** This returns additional remark text belonging to the current product/variant selected
   * @return {string}
   */
  const getAdditionalRemarkValue = () => {
    const currentID =
      state.activeVariant > -1
        ? product.variants[state.activeVariant].variant_id
        : product.id;
    return state.additionalRemark.find((item) => item.id === currentID)?.remark || '';
  };

  /** This adds additional remark to product/variants_selected before navigating to cart page
   * @param {*} cart - updated Cart object after Buy now click
   * @return {Promise}
   */
  const saveAdditionalRemark = (cart) =>
    new Promise((resolve) => {
      const presentCart = cart || cartData;
      const itemIndexInCart = itemIndexFromCart(presentCart, product);
      // Return from here if no object with remark is present
      if (
        itemIndexInCart === -1 ||
        state.additionalRemark.findIndex((item) => item.remark?.trim() !== '') === -1
      ) {
        resolve(presentCart);
        return;
      }
      const newItems = presentCart?.items?.map((item) => {
        if (item.item_id === product.id) {
          if (state.activeVariant === -1)
            return {
              ...item,
              additional_remark:
                state.additionalRemark.find((remarkItem) => remarkItem.id === product.id)
                  ?.remark || '',
            };
          else
            return {
              ...item,
              variants_selected: item.variants_selected.map((variant) => {
                const presentItem = state.additionalRemark.find(
                  (remarkItem) => remarkItem.id === variant.variant_id
                );
                if (presentItem)
                  return {
                    ...variant,
                    additional_remark: presentItem.remark,
                  };
                else return variant;
              }),
            };
        } else return item;
      });
      const newCartData = {
        ...presentCart,
        items: newItems,
      };
      dispatch(
        setCart(newCartData, (data) => {
          dispatch(saveCart(data));
          resolve(newCartData);
        })
      );
    });

  const goToCart = async (cart) => {
    await saveAdditionalRemark(cart);
    router.push(getRoute(PATH.CART, storeInfo?.store_info?.domain));
  };

  const shouldReviewItem = () => {
    if (reviewSettings?.verified_buyer) return verifedBuyer;
    return true;
  };

  const scrollToReviewsSection = () => {
    if (!shouldReviewItem()) return;
    document.getElementById('reviews-section').scrollIntoView();
  };

  const commonCartCtaProps = {
    goToCart,
    returnItemData,
    itemIndexInCart,
    onBuyNowClick,
    handleCart,
    disabledAdditionComponent,
    variantOutOfStock,
    isPDPPage: true,
  };
  function handleShowImageDescriptionModal() {
    setShowImageDescModal(!showImageDescModal);
  }

  const shouldApplyStylesAccordingToAspectRatio = () =>
    storeInfo?.theme?.custom_theme_flag &&
    !isMobile &&
    storeInfo?.theme?.product_aspect_ratio !== 100;

  const getPdpMainDetailsStylesAccordingToImageAspectRatio = () => {
    const isCustomWebsite = storeInfo?.theme?.custom_theme_flag;
    const aspect_ratio = storeInfo?.theme?.product_aspect_ratio;
    if (!isCustomWebsite || isMobile) return {};
    if (aspect_ratio < 100) {
      return {
        flex: '0 1 auto',
        paddingLeft: 65,
      };
    }
    return {};
  };

  const renderDesktopCtaButtonAccordingToStoreType = () => {
    if (!product?.variants?.length && isB2bStore) {
      return (
        <B2bRequestForQuoteDesktop
          openRfqFormModal={toggleRfqFormModal}
          toggleAuthModal={toggleAuthModal}
          product={product}
          storeInfo={storeInfo}
        />
      );
    }
    if (
      isNotifyMeFeatureVisible &&
      isNotifyProductEnabled() &&
      !product.available &&
      !product?.variants?.length
    ) {
      return <NotifyProduct product={product} />;
    }
    return (
      !product?.variants?.length && (
        <div className="flex">
          <CartCtaDesktop {...commonCartCtaProps} product={product} />
        </div>
      )
    );
  };

  const renderMobileCtaButtonAccordingToStoreType = () => {
    if (isB2bStore) {
      return (
        <B2bRequestForQuoteMobile
          openRfqFormModal={toggleRfqFormModal}
          toggleAuthModal={toggleAuthModal}
          product={product}
          storeInfo={storeInfo}
          activeVariant={product?.variants?.[state.activeVariant]}
        />
      );
    }
    return <CartCtaMobile {...commonCartCtaProps} product={product} />;
  };

  const toggleAuthModal = () => {
    if (userData?.isLogin && state.showAuthModal) {
      setState((state) => ({ ...state, showAuthModal: false }));
    } else if (userData?.isLogin && !state.showAuthModal) {
      setState((state) => ({ ...state, showAuthModal: false }));
    } else {
      setState((state) => ({ ...state, showAuthModal: !state.showAuthModal }));
    }
  };

  return (
    <div className="pre-pdp-page">
      <FullPageLoader />
      <div>
        {/* Header */}
        {specificThemeRender(
          storeInfo?.theme,
          storeInfo?.store_premium_theme,
          storeInfo?.premium
        )?.components?.Header?.map((layout) => {
          return getThemeComponent(layout.sub_type, layout.name, layout);
        })}
        {/* Main Content */}
        <main className="pdp__main">
          <article
            className="pdp__main--content"
            vocab="http://schema.org/"
            typeof="Product"
          >
            {isComponentMounted && (
              <div
                className={shouldApplyStylesAccordingToAspectRatio() ? 'flexAuto' : ''}
              >
                <div className="pdp__main--content--leftContent">
                  {isMobile ? (
                    <MobileImageComponent
                      productData={product}
                      handleShowImageDescriptionModal={handleShowImageDescriptionModal}
                      showImageDescModal={showImageDescModal}
                      activeIdx={state.activeVariant}
                      mainImageIndexFromPdp={mainImageIndexFromPdp}
                      setMainImageIndexFromPdp={setMainImageIndexFromPdp}
                    />
                  ) : (
                    <DesktopImageComponent
                      productData={product}
                      handleShowImageDescriptionModal={handleShowImageDescriptionModal}
                      activeIdx={state.activeVariant}
                      mainImageIndexFromPdp={mainImageIndexFromPdp}
                      setMainImageIndexFromPdp={setMainImageIndexFromPdp}
                    />
                  )}
                  {isStoreServiceBased() && !isB2bStore && (
                    <div className="pdp__main--content--remarks-input-wrapper">
                      <input
                        className={`pdp__main--content--remarks-input-wrapper__input ${
                          !getAdditionalRemarkValue() ? 'no-count-shown' : ''
                        }`}
                        placeholder="Additional Remarks, eg. Time slot, etc."
                        onChange={(e) => handleAdditionalRemarksInput(e.target.value)}
                        value={getAdditionalRemarkValue()}
                        maxLength={200}
                        disabled={checkIsAdditionalRemarkDisabled()}
                      />
                      {getAdditionalRemarkValue() ? (
                        <p className="pdp__main--content--remarks-input-wrapper__text-counter">
                          {getAdditionalRemarkValue().length}/200
                        </p>
                      ) : null}
                    </div>
                  )}

                  {/* Add to cart & Buy Now button */}
                  {renderMobileCtaButtonAccordingToStoreType()}
                </div>
              </div>
            )}
            {isComponentMounted && (
              <section
                style={getPdpMainDetailsStylesAccordingToImageAspectRatio()}
                className="pdp__main--details"
              >
                <div className="details__box">
                  <h1 className="details__box--name tw-my-0" property="name">
                    {product?.name}
                  </h1>
                  {product && product.name && (
                    <article className="details__box--categoryname">
                      {product?.brand_name}
                    </article>
                  )}
                  {product?.store_item_review_rating?.review_rating &&
                  product?.store_item_review_rating?.review_rating?.[0]?.avg_rating &&
                  reviewSettings?.status &&
                  isCRRFeatureUnlocked ? (
                    <div
                      className="inline-flex items-center mt10px pv6px ph8px br2"
                      style={{ backgroundColor: '#f5f5f5' }}
                    >
                      <RatingBox
                        isVisible={
                          product?.store_item_review_rating?.review_rating?.[0]
                            ?.avg_rating
                        }
                        isPdp={true}
                        rating={
                          product?.store_item_review_rating?.review_rating &&
                          product?.store_item_review_rating?.review_rating[0]?.avg_rating
                        }
                        hideRDFa
                        isNewStyledRatingBox={true}
                      />
                      <p className="mv0 f14px fw4 black-color pl8px">
                        {product?.store_item_review_rating?.ratings_count} Rating
                        {product?.store_item_review_rating?.ratings_count > 1 ? 's' : ''}
                      </p>
                    </div>
                  ) : null}
                  {/* product pricing */}
                  {isB2bStore ? (
                    <B2bProductPriceRange
                      storeInfo={storeInfo}
                      price_range={state.cost.price_range}
                    />
                  ) : (
                    <article className="details__box--price">
                      <div className="details__box--price-container" rel="schema:offers">
                        <meta
                          property="schema:availability"
                          content={`https://schema.org/${
                            product.available ? 'InStock' : 'OutOfStock'
                          }`}
                        />
                        <meta property="schema:priceCurrency" content="INR" />
                        <span
                          className="details__box--price-value details__box--price-discounted"
                          style={{
                            color: storeInfo?.theme?.colors?.primary_color,
                          }}
                        >
                          ₹
                          <span property="schema:price">
                            {state.cost?.discounted_price}
                          </span>
                          <meta
                            property="schema:priceValidUntil"
                            content={moment(new Date())
                              .add(1, 'year')
                              .format('YYYY-MM-DD')}
                          />
                        </span>
                        {state.cost?.price !== state.cost?.discounted_price && (
                          <span className="details__box--price-value details__box--price-actual">
                            ₹{state.cost?.price}
                          </span>
                        )}
                      </div>
                      {!!state.discountPercentage && !isB2bStore && (
                        <span className="details__box--price-value details__box--price-percentage">
                          {state.discountPercentage}% OFF
                        </span>
                      )}
                    </article>
                  )}
                  {/* product emi and bank offers */}
                  {isStoreGstIncluded() && isComponentMounted && (
                    <article className="details__box-gst-tax-inclusive">
                      Inclusive of all taxes
                    </article>
                  )}
                  {isStoreGstExcluded() && isComponentMounted && (
                    <article className="details__box-gst-tax-exclusive">
                      +{product?.tax?.gst}% GST Charges
                    </article>
                  )}
                  <article className="details__box--additional-offer">
                    {checkForEmiOptionsShowcase() && !isB2bStore ? (
                      <div className="flex pre overflow-hidden">
                        <b>EMI</b> starts at {CURRENCY_SYMBOL}
                        {allEmiOptions?.min_emi_amount}/month{' '}
                        <span
                          className="flex flex-auto items-center"
                          onClick={toggleEmiModal}
                        >
                          Know More{' '}
                          <img
                            alt="Know More"
                            src="/assets/images/blue-carat.png"
                            width="14px"
                          />
                        </span>
                      </div>
                    ) : null}
                    {paymentOffersList?.length ? (
                      <div className="flex pre overflow-hidden">
                        <b>Bank Offer</b> available{' '}
                        <span
                          className="flex flex-auto items-center"
                          onClick={toggleBankOfferModal}
                        >
                          Know More{' '}
                          <img
                            alt="Know More"
                            src="/assets/images/blue-carat.png"
                            width="14px"
                          />
                        </span>
                      </div>
                    ) : null}
                  </article>
                  {/* Review Product */}
                  {deviceWidth > MAX_MOBILE_WIDTH &&
                  userData?.isLogin &&
                  reviewSettings?.status &&
                  isCRRFeatureUnlocked ? (
                    <>
                      <div
                        className="flex items-center pv8px pointer"
                        onClick={scrollToReviewsSection}
                        style={{
                          color: shouldReviewItem() ? '#28292C' : '#E2E2E2',
                        }}
                      >
                        <p
                          data-tip
                          data-for="review-this-product"
                          className="fw6 f14px pr8px mv0"
                        >
                          Review this product
                        </p>
                        <img
                          alt="Review this product"
                          src={
                            shouldReviewItem()
                              ? '/assets/images/right-arrow.svg'
                              : '/assets/images/grey-right-arrow.svg'
                          }
                          width="16px"
                          height="8px"
                        />
                      </div>
                      <ReactTooltip
                        id="review-this-product"
                        place="bottom"
                        multiline={true}
                        effect="solid"
                        padding="8px"
                        disable={shouldReviewItem()}
                      >
                        <p className="mv0 fw5 f12px">
                          Only buyers of this item can submit reviews. If you have any
                          <br />
                          concerns, please share them with us and we would look into it.
                        </p>
                      </ReactTooltip>
                    </>
                  ) : null}
                  {/* product variants */}
                  {!isB2bStore &&
                  !product?.variants_count &&
                  checkForLimitedQuantity(product) ? (
                    <article className="highlighter-red-color f12px mt2">
                      Hurry! Only {product?.available_quantity} units left!
                    </article>
                  ) : null}
                  {/* store closed section */}
                  {storeInfo?.services?.store_flag === 0 && (
                    <article className="details__box--store-closed">
                      <span className="details__box--store-closed-icon">
                        <NoStoreInfoIcon />
                      </span>
                      <span className="details__box--store-closed-para">
                        <p>
                          We are not accepting online orders right now. For queries, call
                          us at{' '}
                          <a href={`tel:${phoneNo}`} onClick={numberClickFunc}>
                            {phoneNo}
                          </a>
                        </p>
                      </span>
                    </article>
                  )}
                </div>
                <VariantDescription
                  itemLowQty={product?.low_quantity}
                  activeIdx={state.activeVariant}
                  onVariantSelect={onVariantSelect}
                  {...commonCartCtaProps}
                  product={product}
                  toggleAuthModal={toggleAuthModal}
                  storeInfo={storeInfo}
                />
                {renderDesktopCtaButtonAccordingToStoreType()}
                <SatisfiedBogoPromos
                  // type={PROMO_APPLICABILITY_TYPES.PRODUCT}
                  productId={product?.id}
                />
                <AllProductPagePromos
                  type={PROMO_APPLICABILITY_TYPES.PRODUCT}
                  productId={product?.id}
                />
                <CheckItemDelivery itemsPrice={state.cost?.discounted_price} />
                {/* <VariantCta product={product} /> */}
                {!!product?.description && (
                  <div className="details__box mt24px ">
                    <h2 className="details__box--descTitle tw-my-0">
                      Product Description
                    </h2>
                    {product?.description.length > 200 ? (
                      <p className="mt8px" property="description">
                        <span
                          className={`details__box--descText`}
                          dangerouslySetInnerHTML={{
                            __html: state.viewDescription
                              ? product?.description
                              : product.description.substr(0, 200),
                          }}
                        />{' '}
                        <span
                          className="details__box--descText-utility"
                          onClick={toggleViewDescription}
                        >
                          ...Read {state.viewDescription ? 'Less' : 'More'}
                        </span>
                      </p>
                    ) : (
                      <p
                        property="description"
                        className={`details__box--descText`}
                        dangerouslySetInnerHTML={{
                          __html: product?.description,
                        }}
                      />
                    )}
                  </div>
                )}
                <MoreInfoTable productData={product} />
              </section>
            )}
          </article>
          {showDetailedDescription ? (
            <DetailedDescription
              className="html-description"
              detailedDescription={product?.description_detail}
            />
          ) : null}
          {reviewSettings?.status && isCRRFeatureUnlocked ? (
            <ReviewsSection
              shouldReviewItem={shouldReviewItem}
              product={product}
              data={product?.store_item_review_rating}
            />
          ) : null}
          {!!availableSuggestions?.length && (
            <section className="pdp__main--suggestion">
              <h3>
                {similar_suggestions ? 'More in category' : 'Other Products in Store'}
              </h3>
              <div className="suggestion__box tw-gap-[20px]">
                {loader && (
                  <>
                    <PDItemCardLoader />
                    <PDItemCardLoader />
                    <PDItemCardLoader />
                  </>
                )}
                <div className="dn-ns db"></div>
                {!loader && (
                  <>
                    {availableSuggestions.map((item, idx) => {
                      return conditionalCardRender(item, idx);
                    })}
                    <div className="suggestion__box--viewall">
                      <span
                        onClick={goToHomePage}
                        style={{
                          cursor: 'pointer',
                          border: `1px solid ${storeInfo?.theme?.colors?.primary_color}`,
                          backgroundColor: storeInfo?.theme?.colors?.primary_color
                            ? storeInfo?.theme?.colors?.primary_color
                            : '#ea5151',
                        }}
                      >
                        View all
                      </span>
                    </div>
                  </>
                )}
              </div>
            </section>
          )}
        </main>

        {/* Footer */}
        {specificThemeRender(
          storeInfo?.theme,
          storeInfo?.store_premium_theme,
          storeInfo?.premium
        )?.components?.Footer?.map((layout) => {
          return getThemeComponent(layout.sub_type, layout.name, layout);
        })}
      </div>
      <VariantModal isRedirect={state.isRedirect} />
      <VariantChooseRepeatModal />
      <VariantSelectedListModal />
      <ImageDescriptionModal
        showImageDescModal={showImageDescModal}
        handleShowImageDescriptionModal={handleShowImageDescriptionModal}
        productData={product}
        activeIdx={state.activeVariant}
        mainImageIndexFromPdp={mainImageIndexFromPdp}
      />
      <EmiModal open={emiModalShow} onClose={toggleEmiModal} />
      <BankOfferModal open={bankOfferModal} onClose={toggleBankOfferModal} />
      <ToastContainer limit={1} key={'pdp-toasts'} />
      <AuthModal toggleModal={toggleAuthModal} isVisible={state.showAuthModal} />
      {personalizedProduct?.personalizationPopUp && <ProductCustomizationPopUp />}
      <QuntityUnavailableAlert />
    </div>
  );
};

export default ProductDescPage;
